<template>
    <div class="adminblogsys">
        <!-- 图片裁剪区域 -->
        <el-dialog :visible.sync="imageUrlClip">
            <ImageClip :imgDataUrl='imgDataUrl' @imgSaveToFile='imgSaveToFile'></ImageClip>
        </el-dialog>
        <div class="control-panel" v-if='!panel'>
            <h3 class="pagename">博客</h3>
            <!-- 搜索区域 -->
            <div class="search">
                <div>
                    <label for="">文章类型:</label>
                    <el-select v-model="articleData.value" placeholder="请选择" name="search">
                        <el-option v-for="item in articleData.options" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="button-box">
                    <el-button icon="el-icon-search" @click='getActiclList'>查询</el-button>
                </div>
            </div>
            <!-- 信息汇总区域 -->
            <div class="tips">总条目数量:<i class="el-icon-loading num" v-if='!type'></i><span class="num" v-else>
                    {{articleData.artical_meta.total}}</span></div>
            <!-- 文章操作面板 -->
            <div class="article-box">
                <!-- 批量操作区域 -->
                <div class="article-all-button-box">
                    <el-button icon="el-icon-edit" @click='showredact(null)'>新增文章</el-button>
                    <el-button icon="el-icon-delete" @click="deleteAllMessage">批量删除</el-button>
                </div>
                <!-- 文章列表操作区域 -->
                <el-table ref="multipleTable" :data="articleData.articleres" tooltip-effect="dark" style="width: 100%"
                    @selection-change="handleSelectionChange" class="from">
                    <!-- 用户勾选区域 -->
                    <el-table-column type="selection" width="50">
                    </el-table-column>
                    <!-- 文章标题 -->
                    <el-table-column prop="title" label="标题" width="">
                    </el-table-column>
                    <!-- 发布状态 -->
                    <el-table-column prop="readable" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div :style="{color:(scope.row.readable==0?'#f00':'#000')}">{{scope.row.readable|handle}}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 博客类型 -->
                    <el-table-column prop="type" label="类型" width="">
                        <template slot-scope="scope">
                            <div :style="{color:(scope.row.readable==0?'#f00':'#000')}">
                                {{scope.row.article_type_id|myartical}}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 发布日期 -->
                    <el-table-column prop="created_at" label="发布" width="">
                    </el-table-column>
                    <!-- 可操作区域 -->
                    <el-table-column label="操作" width="">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click='showredact(scope.row)'>编辑</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click='deleteMessage(scope.row)'>删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next" :total="articleData.artical_meta.total_pages*10"
                    @current-change="currentPage" class="pages">
                </el-pagination>
            </div>
        </div>
        <div class="panel-container" v-else>
            <el-page-header @back="showredact" content="博客编辑页面"></el-page-header>
            <div class="panel-body flexrow">
                <!-- 图片封面上传区域 -->
                <div class="text-container" v-if='!downurl'>
                    <!-- <el-upload class="upload" drag action="" :http-request="httprequest" :show-file-list="false"> -->
                    <!-- <i class="el-icon-upload"></i> -->
                    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i class="el-icon-plus" v-else></i>
                    </el-upload> -->
                    <el-upload action="" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove" :http-request='upMainImg' :on-exceed='onexceed'
                        :before-upload='beforeAvatarUpload' :show-file-list="false">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i class="el-icon-plus" v-else></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                    <!-- 主图预览 -->
                    <!-- <div class="main-img" :style="{backgroundImage:'url('+mainImg+')'}" v-if='!save'></div> -->
                </div>
                <!-- 文章编辑区域 -->
                <div class="article-img">
                    <!-- 文章标题 -->
                    <div class="form-line">
                        <div class="artCaption"><span class="star">*</span>文章标题</div>
                        <el-input type="text" placeholder="请输入内容" v-model="articleData.formList.title" maxlength="300"
                            autofocus show-word-limit>
                        </el-input>
                    </div>
                    <!-- SEO标题 -->
                    <div class="form-line">
                        <div class="artCaption">SEO标题优化</div>
                        <el-input type="text" placeholder="SEO标题优化，默认可不填" v-model="articleData.formList.seo_title"
                            maxlength="300" autofocus show-word-limit>
                        </el-input>
                    </div>
                    <!-- SEO描述 -->
                    <div class="form-line">
                        <div class="artCaption">SEO描述</div>
                        <el-input type="text" placeholder="SEO描述，默认可不填" v-model="articleData.formList.seo_description"
                            maxlength="300" autofocus show-word-limit>
                        </el-input>
                    </div>
                    <!-- 文章内容 -->
                    <div class="form-line">
                        <div class="artCaption"><span class="star">*</span>文章内容</div>
                        <!-- 富文本编辑器 -->
                        <div class="editor" id="editor" ref="editor"></div>
                        <!-- 文本类型 -->
                        <div style="margin: 20px 0 20px">
                            <el-radio-group v-model="articleData.formList.article_type_id">
                                <el-radio label="1" border>线上活动</el-radio>
                                <el-radio label="2" border>线下活动</el-radio>
                                <el-radio label="3" border>营销工具</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="artCaption" v-if='downurl'>营销工具下载链接</div>
                        <!-- <el-input type="text" placeholder="请填写营销工具的下载链接" v-model="articleData.formList.main_img_url"
                            autofocus show-word-limit class="download" v-if='downurl'>
                        </el-input> -->
                        <el-button v-if='save' @click="upArtice">保存上传</el-button>
                        <el-button v-else @click='upChangeArtice'>保存编辑</el-button>
                        <el-button @click='showredact'>取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import E from 'wangeditor'//引入富文本编辑器
    import ImageClip from './imageClip'//引入图片裁剪模块
    export default {
        name: 'AdminBlogSys',
        components: {
            ImageClip,//图片裁剪功能模块
        },
        data() {
            return {
                // 数据是否获取完成
                type: false,
                //文章编辑面板的切换
                panel: false,
                //文章上传按钮的切换
                save: true,
                // 富文本编辑器内容
                editor: '',
                //用户浏览的当前页码
                pagenumber: 1,
                //用户的选择信息
                ids: [],
                //文章的id
                id: '',
                //用户预览文章主图
                mainImg: '',
                //是否是上传营销工具类型
                downurl: false,
                // 组件的所有数据集合
                articleData: {
                    // 选择的内容
                    value: '1',
                    // 筛选文章的状态 显示为1 隐藏为0
                    options: [
                        {
                            value: '1',
                            label: '线上活动'
                        },
                        {
                            value: '2',
                            label: '线下活动'
                        },
                        {
                            value: '3',
                            label: '营销工具'
                        }
                    ],
                    userList: {
                        title: ''
                    },
                    //formData的数据
                    formList: {
                        title: '',//"文章标题",
                        content: '', //"文章的内容",
                        seo_title: '',//"seo标题",
                        seo_description: '',//"seo描述",
                        readable: 1,//文章是否可见 默认为0 不可见，1为可见
                        article_type_id: '',//文章类型的id
                        // filenames: [],//绑定文章的详情图片
                        main_img_url: '',//"文章主图路径"
                        recommend: 0,
                    },
                    // 获取关于文章的总数据
                    artical_meta: '',
                    articleres: [
                    ]
                },
                // 用户勾选文章列表的选择结果
                multipleSelection: [],
                //编辑界面获取的图片
                imageUrl: '',
                //显示图片展示
                dialogVisible: false,
                //图片展示地址
                dialogImageUrl: '',
                //图片裁剪模块
                imageUrlClip: false,
                //本地图片url
                imgDataUrl: '',
                //临时存储图片的name
                imgDataName: '',
                //oss上传计数器
                osssikesum: 0
            }
        },
        // 过滤器
        filters: {
            handle(val) {
                return val == 0 ? "未发布" : "已发布"
            },
            myartical(val) {
                if (val === 1) {
                    return '线上活动'
                } else if (val === 2) {
                    return '线下活动'
                } else {
                    return '营销工具'
                }
                // return val == '' ? "知识中心" : "博客文章"
            }
        },
        updated() {
            this.editorConfig();//数据更新之后初始化富文本
        },
        mounted() {
            this.getActiclList()
        },
        methods: {
            // 用户勾选文章列表的选择结果
            handleSelectionChange(val) {
                this.ids = []
                for (var i in val) {
                    this.ids.push(val[i].id)
                }
            },
            //获取文章列表
            getActiclList() {
                this.pagenumber = 1
                this.$getToken.get(this.$API.articlesList, {
                    params: {
                        article_type_id: this.articleData.value
                    }
                })
                    .then(res => {
                        this.articleData.artical_meta = res.data.meta.pagination//获取文章列表的数据汇总
                        this.articleData.articleres = res.data.data//获取文章列表的文字数据
                        this.type = true
                        // console.log(this.articleData.articleres)
                    })
                    .catch(err => {
                        this.$message.error('文章列表获取失败，错误编码：' + err.response.status)
                    })
            },
            //图片上传
            httprequest(file) {
                this.articleData.formList.main_img_url = file.file//将文件赋值
            },
            //翻页
            currentPage(val) {
                console.log(val)
            },
            // 是否进入文章编辑页面
            showredact(num) {
                if (num == null) {
                    this.save = true
                    this.panel = !this.panel
                    this.createfrom()
                } else {
                    this.save = false
                    this.panel = !this.panel
                    this.getChangeArticl(num)
                }
            },
            //获取当前用户选中信息
            getChangeArticl(obj) {
                this.articleData.formList.title = obj.title
                this.articleData.formList.content = obj.content
                obj.seo_title == null ? this.articleData.formList.seo_title = '' : this.articleData.formList.seo_title = obj.seo_title
                obj.seo_description == null ? this.articleData.formList.seo_description = '' : this.articleData.formList.seo_description = obj.seo_description
                // this.mainImg = obj.main_img_url
                this.imageUrl = obj.main_img_url
                this.articleData.formList.article_type_id = obj.article_type_id
                this.id = obj.id
                // console.log(obj.seo_description)
            },
            //改变页数
            currentPage(val) {
                this.pagenumber = val
                this.$getToken.get(this.$API.articlesList, {
                    params: {
                        type: this.articleData.value,
                        page: this.pagenumber
                    }
                }).then(res => {
                    this.articleData.artical_meta = res.data.meta.pagination//获取文章列表的数据汇总
                    this.articleData.articleres = res.data.data//获取文章列表的文字数据
                }).catch(err => { this.$message.error("服务器开了小差，请刷新重试") })
            },
            //文章添加功能
            upArtice() {
                let fromData = new FormData()
                for (var i in this.articleData.formList) {
                    if (i === 'filenames') {
                        if (this.articleData.formList[i].length !== 0) {
                            fromData.append('filenames[]', this.articleData.formList[i])
                            continue;
                        } else {
                            continue;
                        }
                    } else {
                        fromData.set(i, this.articleData.formList[i])
                    }
                }
                this.$getToken.post(this.$API.articles, fromData).then(res => {
                    this.panel = !this.panel//返回文章列表
                    this.currentPage(this.pagenumber)//从新拉取当前浏览页
                    this.createfrom()//初始化
                    this.$message.success("文章添加成功")
                }).catch(err => {
                    this.$message.error("文章添加失败，请刷新重试")
                })
            },
            //文章编辑功能
            upChangeArtice() {
                let fromData = new FormData()
                for (var i in this.articleData.formList) {
                    if (i === 'filenames') {
                        if (this.articleData.formList[i].length !== 0) {
                            fromData.append('filenames[]', this.articleData.formList[i])
                            continue;
                        } else {
                            continue;
                        }
                    } else if (this.articleData.formList[i] === '') {
                        continue;
                    } else {
                        fromData.set(i, this.articleData.formList[i])
                    }
                }
                this.$getToken.post(this.$API.changeArtimcl(this.id), fromData).then(res => {
                    this.panel = !this.panel//返回文章列表
                    this.currentPage(this.pagenumber)//从新拉取当前浏览页
                    this.$message.success("文章修改成功")
                }).catch(err => {
                    this.$message.error("文章修改失败，请刷新重试")
                })
            },
            //删除文章
            deleteMessage(val) {
                this.ids = []//初始化数据
                this.ids.push(val.id)
                this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '正在删除!'
                    });
                    this.$getToken.delete(this.$API.deletearticles, {
                        params: {
                            ids: this.ids
                        }
                    }).then(res => {
                        this.$message.success("已成功删除")
                        this.currentPage(this.pagenumber)//从新拉取当前浏览页
                    }).catch(err => { this.$message.error("删除失败，seo默认文章不支持删除") })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //批量删除文章
            deleteAllMessage() {
                this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '正在删除请稍后!'
                    });
                    this.$getToken.delete(this.$API.deletearticles, {
                        params: {
                            ids: this.ids
                        }
                    }).then(res => {
                        this.$message.success("已成功删除")
                        this.currentPage(this.pagenumber)//从新拉取当前浏览页
                    }).catch(err => { this.$message.error("删除失败，seo默认文章不支持删除") })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //初始化内容
            createfrom() {
                this.articleData.formList.title = ''
                this.articleData.formList.content = ''
                this.articleData.formList.filenames = []
                this.articleData.formList.main_img_url = ''
                this.articleData.formList.seo_title = ''
                this.imageUrl = ''
                this.articleData.formList.seo_description = ''
            },
            //====================================================================图片裁剪==============================================================
            onexceed(file) {//超出上传数量
                this.$message.error('商品主图最多添加1张,如需替换请删除主图再上传新图')
            },
            beforeAvatarUpload(file) {//图片上传前的验证
                this.imgDataName = file.name
                let reader = new FileReader()
                reader.readAsDataURL(file);
                reader.onload = () => {
                    this.imgDataUrl = reader.result
                    this.imageUrlClip = true//打开图片裁剪模块
                }
            },
            upMainImg(file) {//图片上传的行为
                this.articleData.formList.main_img_url = file.file
            },
            handlePictureCardPreview(file) {//点击图片列表
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove() {//移除图片
                this.articleData.formList.main_img_url = ''
                this.imageUrl = ''

            },
            imgSaveToFile(data) {//裁剪后的图片base64
                // console.log(data)
                this.imageUrl = data
                this.articleData.formList.main_img_url = this.dataURLtoFile(data)
                this.imageUrlClip = false
            },
            dataURLtoFile(dataurl) {
                var arr = dataurl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], this.imgDataName, { type: mime });
            },
            //====================================================================图片裁剪end==============================================================
            //富文本配置
            editorConfig() {
                let that = this;
                that.editor = new E("#editor");//editor实例化
                //配置参数
                that.editor.customConfig.menus = [
                    'head',  // 标题
                    'bold',  // 粗体
                    'fontSize',  // 字号
                    'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'foreColor',  // 文字颜色
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'image',  // 插入图片
                    'undo',  // 撤销
                    'redo'  // 重复
                ];
                //实时获取富文本内容
                that.editor.customConfig.onchange = function (text) {
                    that.articleData.formList.content = text;
                };
                that.editor.customConfig.showLinkImg = false;//隐藏“网络图片”tab
                // that.editor.customConfig.uploadImgServer = '/upload';//显示本地上传到服务器
                // that.editor.customConfig.customUploadImg = (files, insert) => {//选择本地图片成功后调用函数执行的钩子

                //     // files 是 input 中选中的文件列表,是数组格式
                //     that.articleData.formList.filenames=[...that.articleData.formList.filenames,...files]//合并数组
                //     console.log( that.articleData.formList.filenames)
                //     // insert 是获取图片 url 后，插入到编辑器的方法

                //     // 上传代码返回结果之后，将图片插入到编辑器中
                // }
                that.editor.customConfig.pasteFilterStyle = false//关闭掉粘贴样式的过滤
                
                that.editor.customConfig.uploadImgShowBase64 = true   // 使用 base64 保存图片
                that.editor.customConfig.zIndex = 10
                //=================================================自定义图片上传方法=============================================================
                that.editor.customConfig.customUploadImg = function (files, insert) {
                    that.getOSStoken(files,insert)
                    // console.log(files)
                    // files 是 input 中选中的文件列表
                    // insert 是获取图片 url 后，插入到编辑器的方法

                    // 上传代码返回结果之后，将图片插入到编辑器中
                    // insert(imgUrl)
                }
                //=================================================自定义图片上传方法end=============================================================
                that.editor.create();//以上配置完成之后调用其create()方法进行创建
                that.editor.txt.html(that.articleData.formList.content);//设置内容在富文本中(必须在update中调用该方法)
            },



            //================================================文件上传oss============================================================================
            getOSStoken(files,insert) {
                //判断是否有需要上传的详情文件
                let _this = this
                if (this.osssikesum <files.length) { //有详情图片的情况下，上传详情图片
                    _this.$getToken.get(_this.$API.getSignature, {
                        params: {
                            bucket: 'public', //默认天public
                            scene: 'article', //添加商品文件
                            type: 'image', //文件的类型
                            fileName: files[_this.osssikesum].name //文件的名字
                        }
                    }).then(res => {
                        _this.upOSS(res,files[_this.osssikesum],insert)
                    }).catch(err => {
                        this.$message.error('创建阿里云商品地址失败,错误编码:' + error.response.status)
                    })
                }
            },
            //==============================================文件上传阿里云=============================================================================
            upOSS(res,file,insert) {
                let myFileData = new FormData()
                myFileData.append('key',res.data.data.dir)
                myFileData.append('policy',res.data.data.policy)
                myFileData.append('OSSAccessKeyId',res.data.data.access_id)
                myFileData.append('signature',res.data.data.signature)
                myFileData.append('callback',res.data.data.callback)
                myFileData.append('file',file)
                myFileData.append('success_action_status',200)
                const dir=res.data.data.dir
                this.$upOss.post('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com', myFileData).then(res => {
                    insert(`https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/${dir}`)

                }).catch(err => {
                    this.$message.error("详情图文件上传失败,请重新上传详情图" + error.response.status);
                })
            },



            // chengeMainurl(value){//改变上传的主图
            //     let that=this
            //     if(value==='3'){
            //         // alert('您选择了营销工具')
            //         that.downurl=true
            //         that.articleData.formList.main_img_url=''
            //     }else{
            //         that.downurl=false
            //     }
            // }

        }
    }
</script>
<style scoped>
    /* 外部容器高度 */
    .adminblogsys {
        height: 100%;
    }

    /* 模块内容标题 */
    .pagename {
        font-weight: bold;
        color: #333333;
        font-size: 20px;
        text-align: left;
    }

    .search {
        margin: 25px 0;
        display: flex;
    }

    label {
        font-size: 16px;
        color: #000;
        margin-right: 15px;
    }

    /* 查询按钮的样式 */
    .button-box {
        margin-left: 15px;
    }

    /* 汇总消息的样式 */
    .tips {
        text-align: left;
        color: #999999;
        font-size: 14px;
        margin: 12px 0;
    }

    .num {
        font-size: 14px;
        color: #999999;
    }

    /* 文章操作面板的样式 */
    .article-box {
        padding: 2% 2% 1%;
        background-color: #ffffff;
    }

    /* 文章编辑页面的头部区域 */
    .panel-container {
        height: 100%;
    }

    /* 文章编辑页面的分区 */
    .panel-body {
        height: 100%;
        padding: 1%;
        background-color: #ffffff;
        overflow: auto;
    }

    .text-container {
        width: 30%;
        height: 100%;
    }

    .article-img {
        flex-grow: 1;
        height: 100%;
    }

    /* 文章编辑页面的操作 */
    .star,
    .el-upload__tip {
        color: red;
    }

    .form-line {
        margin: 20px 0;
    }

    .artCaption {
        margin-bottom: 15px;
        font-size: 20px;
    }

    .article-img>.form-line:nth-of-type(1) {
        margin-top: 0;
    }

    /* 富文本 */
    .editor {
        width: 1055px;
        margin-bottom: 40px;
        background-color: #fff;
    }

    .pages {
        text-align: center;
        padding: 20px 0;
    }

    .from {
        height: 50vh;
        overflow-y: auto;
    }

    .main-img {
        width: 80%;
        height: 200px;
        background: #666666 no-repeat center;
        background-size: cover;
    }

    .download {
        margin-bottom: 20px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/adminblogsys.vue